(function () {
    'use strict';

    angular.module('app.subscriptions', [
        // Angular modules
        'ngRoute'

        // Custom modules

        // 3rd Party Modules

    ]);
})();